<template>
  <div>
    <PageContent
      ref="pageContentRef"
      :dataList="dataList"
      :title="dataList.trace_name || '错误'"
    >
      <template v-slot="itemData">
        <div class="circulation">
          <div class="item-wrap">
            <div
              class="left"
              v-for="(item, index) in itemData.itemData.op.op"
              :key="index"
            >
              <div :class="['tle', index === 0 ? 'first' : '']">
                {{ item.config_title }}
              </div>
              <div class="item" v-if="item.config_type == 0">
                <span v-html="item.config_content">{{
                  item.config_content
                }}</span>
              </div>
              <div class="item" v-if="item.config_type == 1">
                <van-swipe
                  class="swipe"
                  indicator-color="#258F79"
                  :autoplay="3000"
                  style="border-radius: 0"
                >
                  <van-swipe-item
                    v-for="(itemInner, index1) in item.picList"
                    :key="index1"
                  >
                    <img v-lazy="itemInner" @click="switch_image(itemInner)" />
                  </van-swipe-item>
                </van-swipe>
                <!-- <swiper ref="mySwiper">
                  <swiper-slide
                    v-for="(itemInner, index1) in item.picList"
                    :key="index1"
                  >
                    <img :src="itemInner"
                  /></swiper-slide>
                  <div class="swiper-pagination" slot="pagination"></div>
                </swiper> -->
              </div>
              <div class="item" v-if="item.config_type == 2">
                <!-- <video :src="item.movieurl" controls></video> -->
                <van-swipe
                  class="swipe"
                  indicator-color="#258F79"
                  :autoplay="2300"
                  style="border-radius: 0"
                >
                  <van-swipe-item
                    v-for="(itemInner, index1) in item.movieurl.split(',')"
                    :key="index1"
                  >
                    <!-- 2 外链直播 -->
                    <template v-if="item.moveType == 2">
                      <!-- <LiveVideo
                        :id="'play' + index + index1"
                        :url="item.movieurl"
                        :ref="'play' + index + index1"
                        @play="videoPlay"
                        :isLive="item.moveType == 1 ? true : false"
                      /> -->

                      <iframe
                        :src="item.movieurl"
                        id="ifId"
                        frameBorder="0"
                        style="width: 100%; height: 100%"
                      ></iframe>
                    </template>
                    <template v-else-if="item.moveType == 1">
                      <video
                        :src="itemInner"
                        controls
                        x5-video-player-type="h5"
                        :poster="
                          item.moviePicurl ||
                          require('@/assets/images/video.png')
                        "
                      ></video>
                    </template>
                    <template v-else>
                      <video
                        :src="itemInner"
                        controls
                        x5-video-player-type="h5"
                        :poster="
                          item.moviePicurl ||
                          require('@/assets/images/video.png')
                        "
                      ></video>
                    </template>
                  </van-swipe-item>
                </van-swipe>
              </div>
            </div>
          </div>
        </div>
      </template>
    </PageContent>
  </div>
</template>

<script>
// import LiveVideo from "@/components/VideoLive.vue";
export default {
  // components: {
  //   LiveVideo,
  // },
  props: {
    dataList: Object,
  },
  watch: {
    dataList: {
      handler() {
        this.$nextTick(() => {
          this.dataList.msgItems.map((res) => {
            //将所有视频地址中的Islive属性分出来 用于判断是直播还是点播
            res.op.op.map((value) => {
              //判断是html播放还是普通外链视频
              if (value.movieurl) {
                let moveurlIndex = value.movieurl.indexOf("html");
                // let parms = this.GetRequest(value.movieurl.substr(moveurlIndex));
                if (moveurlIndex == -1) {
                  //不存在  外链视频
                  value.moveType = 1;
                } else {
                  // 存在 外链直播视频
                  value.moveType = 2;
                }
              }
            });
          });
        });
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      index: 0,
      info: [
        {
          title: "基本信息",
          children: [
            { name: "基地: ", value: "品品香茶业种植基地" },
            { name: "面积: ", value: "1200亩" },
            { name: "地址: ", value: "福鼎市桐城资国寺村山下" },
            { name: "负责人: ", value: "刘小明" },
          ],
        },
        {
          title: "基地概览",
          children: [{ img: require("@/assets/images/test/11.png") }],
        },
        {
          title: "人工除草",
          children: [{ img: require("@/assets/images/test/12.png") }],
        },
        {
          title: "物理除虫",
          children: [{ img: require("@/assets/images/test/13.png") }],
        },
        {
          title: "整地",
          children: [{ img: require("@/assets/images/test/14.png") }],
        },
        {
          title: "施肥",
          children: [{ img: require("@/assets/images/test/15.png") }],
        },
        {
          title: "采摘",
          children: [{ img: require("@/assets/images/test/16.png") }],
        },
        {
          title: "原料入库",
          children: [
            { name: "负责人: ", value: "王爱国" },
            { name: "地点: ", value: "半成品仓库" },
          ],
        },
      ],
      listData: {},
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    try {
      this.$setApptitle("链白茶防伪溯源");
    } catch {
      console.log("not webview");
    }
    console.log(this.$route.params.defaultId);
    this.defaultId = this.$route.query.defaultId;
    this.listData = JSON.parse(localStorage.getItem("idInObj"))[this.defaultId];
    console.log(this.listData);
    console.log(this.listData.msgItems);

    // let getItem = JSON.parse(localStorage.getItem('getItemVal'))
    // this.index = getItem.i
    // if(this.$route.params.id == this.index){
    //   this.options = getItem.v
    //   console.log(this.options)
    // }
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  //方法
  methods: {
    //是否展开
    isShowPage() {
      if (this.dataList.msgItems) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.pageContentRef.flagBoxFather();
            setTimeout(() => {
              this.$refs.pageContentRef.titleChildSwitch(
                0,
                this.dataList.msgItems[0].txid
              );
            }, 500);
          });
        });
      }
    },
    videoPlay(id) {
      console.log(id);
      let vId = localStorage.getItem("videoId");
      console.log(vId);
      //处理直播视频只能一次播放一个
      if (vId && vId != "undefined" && vId != id) {
        this.$refs[vId][0].stopPlay();
      }
      localStorage.setItem("videoId", id);
    },
  },
  // watch: {
  //   $route: {
  //     handler(nv) {
  //       // if (isNaN(Number(nv.query.defaultId))) {
  //       //   console.log(nv.params.id);
  //       //   // let getItem = JSON.parse(localStorage.getItem("getItemVal"));
  //       //   this.$refs.pageContentRef.isDefalutShow();
  //       //   this.listData = JSON.parse(localStorage.getItem("idInObj"))[
  //       //     nv.query.defaultId
  //       //   ];
  //       //   this.isShowPage();
  //       }
  //     },
  //   },
  //   deep: true,
  // },
};
</script>
<style lang="scss" scoped>
.circulation {
  padding: 0 40px;
  .item-wrap {
    .left {
      position: relative;
      margin-bottom: 32px;
      padding-left: 40px;
      border-left: 5px solid #26907a;
      &::before {
        content: "";
        position: absolute;
        top: 20px;
        left: -3px;
        transform: translateX(-50%);
        width: 28px;
        height: 28px;
        background: #f5f5f5;
        border: 5px solid #26907a;
        border-radius: 50%;
      }
      &:first-child::before {
        content: "";
        position: absolute;
        top: 0;
        left: -3px;
        transform: translateX(-50%);
        width: 28px;
        height: 28px;
        background: #f5f5f5;
        border: 5px solid #26907a;
        border-radius: 50%;
      }
      .tle {
        position: relative;
        top: 5px;
        padding: 14px 32px;
        box-sizing: border-box;
        text-align: center;
        display: inline-block;
        background-color: #26907a;
        font-size: 28px;
        color: #fff;
        border-radius: 16px;
        &::before {
          position: absolute;
          top: 50%;
          left: -12px;
          transform: translateY(-50%);
          content: "";
          width: 12px;
          height: 8px;
          background: #26907a;
        }
      }
      .first {
        top: -14px;
      }
      .item {
        margin-top: 20px;
        margin-bottom: 16px;
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 38px;
        color: #222222;
        img {
          width: 470px;
          height: 264px;
        }
        span {
          font-size: 28px;
          color: #808080;
        }
      }
      video {
        width: 470px;
        height: 264px;
      }
    }
  }
}
</style>
